module.exports = __webpack_public_path__ + "static/media/keep-safe-tip05.97ef3681.png";